import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../Translations';

interface Props {}

const Head: React.FC<Props> = ({}) => (
  <>
    <div className="flex items-center mb-5">
      <h2 className="text-2xl font-semibold text-gray-900 items-center">
        <T kind="People" />
      </h2>
    </div>
  </>
);

export default observer(Head);
